<div class="litigation-wrapper">
  <!-- Loader -->
  <div *ngIf="loading" class="text-center my-3">
    <i class="fa fa-spinner fa-spin"></i>
    <span class="ms-2">Loading litigation data...</span>
  </div>

  <!-- Error -->
  <div
    *ngIf="
      !loading &&
      errorMessage &&
      litigationData?.length === 0 &&
      otherLitigationData?.length === 0
    "
    class="alert alert-danger"
  >
    {{ errorMessage }}
  </div>

  <!-- No data -->
  <div
    *ngIf="
      !loading &&
      !errorMessage &&
      litigationData?.length === 0 &&
      otherLitigationData?.length === 0
    "
    class="alert alert-info"
  >
    No litigation data found.
  </div>

  <!-- MAIN BLOCK 1: Litigation data -->
  <div *ngIf="!loading && litigationData?.length" class="litigation-block">
    <!-- LEFT SIDE -->
    <div class="litigation-side">
      <div class="litigation-side-header">Litigation data</div>
    </div>
    <!-- RIGHT SIDE -->
    <div class="litigation-main">
      <div class="litigation-table-wrapper">
        <div class="table-responsive">
          <table class="table table-bordered litigation-table" id="innertable">
            <thead style="font-size: 12px">
              <tr>
                <th>Case Number</th>
                <th>Filed Date</th>
                <th>Plaintiffs</th>
                <th>Defendants</th>
                <th>Court Name</th>
                <th>Judge Name</th>
                <th>Patents in Case</th>
                <th>Case Status</th>
                <th>Termination Date</th>
                <th>PDF File</th>
              </tr>
            </thead>

            <tbody style="font-size: 10px">
              <ng-container *ngFor="let row of litigationData">
                <tr>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px">
                      <button
                        *ngIf="hasAppealCases(row.appealCases)"
                        class="btn btn-sm btn-outline-info"
                        style="padding: 2px 6px; font-size: 10px"
                        (click)="toggleExpand(row)"
                      >
                        <i
                          [class]="row.expanded ? 'fa fa-minus' : 'fa fa-plus'"
                        ></i>
                      </button>
                      {{ row.caseNumber || "N/A" }}
                    </div>
                  </td>
                  <td>{{ row.filedDate || "N/A" }}</td>
                  <td>{{ row.plaintiff || "N/A" }}</td>
                  <td>{{ row.defendant || "N/A" }}</td>
                  <td>{{ row.courtName || "N/A" }}</td>
                  <td>{{ row.judgeName || "N/A" }}</td>
                  <td>{{ row.patentsAtIssue || "N/A" }}</td>
                  <td>{{ row.caseStatus || "N/A" }}</td>
                  <td>{{ row.terminationDate || "N/A" }}</td>
                  <td class="text-center">
                    <ng-container *ngIf="row.pdfFile; else noPdf">
                      <i
                        class="fa fa-file-pdf-o pdf-icon"
                        title="Open case PDF"
                        (click)="openPdf(row)"
                        style="cursor: pointer; color: red"
                      ></i>
                    </ng-container>
                    <ng-template #noPdf> N/A </ng-template>
                  </td>
                </tr>
                <tr *ngIf="row.expanded">
                  <td colspan="10">
                    <div
                      style="
                        padding: 10px;
                        background-color: #f8f9fa;
                        border-radius: 4px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
                      "
                    >
                      <div
                        style="
                          font-weight: bold;
                          margin-bottom: 8px;
                          color: #495057;
                          font-size: 11px;
                        "
                      >
                        <i class="fa fa-info-circle text-info"></i> Appeal
                        Case(s)
                      </div>
                      <table
                        class="table table-bordered table-sm"
                        style="background-color: white; margin-bottom: 0"
                      >
                        <thead
                          style="background-color: #e9ecef; font-size: 11px"
                        >
                          <tr>
                            <th>Case Number</th>
                            <th>Court</th>
                            <th>Appellant</th>
                            <th>Filed Date</th>
                            <th>Case Status</th>
                            <th>Termination Date</th>
                            <th class="text-center">PDF</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let appeal of getFilteredAppeals(row.appealCases)
                            "
                          >
                            <td>{{ appeal["Appeal Case Number"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Court"] || "N/A" }}</td>
                            <td>{{ appeal["Appellant"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Filed Date"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Case Status"] || "N/A" }}</td>
                            <td>
                              {{ appeal["Appeal Termination Date"] || "N/A" }}
                            </td>
                            <td class="text-center">
                              <a
                                *ngIf="
                                  appeal['Appeal PDF Path'] &&
                                    appeal['Appeal PDF Path'] !== 'N/A';
                                  else noAppealPdf
                                "
                                (click)="
                                  openAppealPdf(appeal['Appeal PDF Path'])
                                "
                                style="
                                  color: #007bff;
                                  cursor: pointer;
                                  text-decoration: underline;
                                "
                              >
                                <i
                                  class="fa fa-file-pdf-o"
                                  style="color: red"
                                  title="Open appeal PDF"
                                ></i>
                              </a>
                              <ng-template #noAppealPdf>N/A</ng-template>
                            </td>
                          </tr>
                          <tr
                            *ngIf="
                              getFilteredAppeals(row.appealCases).length === 0
                            "
                          >
                            <td colspan="7" class="text-center text-muted">
                              No appeal cases available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- MAIN BLOCK 2: Other Litigation Records -->
  <div *ngIf="!loading && otherLitigationData?.length" class="litigation-block">
    <!-- LEFT SIDE -->
    <div class="litigation-side">
      <div class="litigation-side-header">Other Litigation Records</div>
    </div>
    <!-- RIGHT SIDE -->
    <div class="litigation-main">
      <div class="litigation-table-wrapper">
        <div class="table-responsive">
          <table
            class="table table-bordered litigation-table"
            id="innertable-other"
          >
            <thead style="font-size: 12px">
              <tr>
                <th>Litigation Category</th>
                <th>Case Number</th>
                <th>Filed Date</th>
                <th>Plaintiffs</th>
                <th>Defendants</th>
                <th>Court Name</th>
                <th>Judge Name</th>
                <th>Patents in Case</th>
                <th>Case Status</th>
                <th>Termination Date</th>
                <th>PDF File</th>
              </tr>
            </thead>

            <tbody style="font-size: 10px">
              <ng-container *ngFor="let row of otherLitigationData">
                <tr>
                  <td>{{ row.litigationCategory || "N/A" }}</td>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px">
                      <button
                        *ngIf="hasAppealCases(row.appealCases)"
                        class="btn btn-sm btn-outline-info"
                        style="padding: 2px 6px; font-size: 10px"
                        (click)="toggleExpand(row)"
                      >
                        <i
                          [class]="row.expanded ? 'fa fa-minus' : 'fa fa-plus'"
                        ></i>
                      </button>
                      {{ row.caseNumber || "N/A" }}
                    </div>
                  </td>
                  <td>{{ row.filedDate || "N/A" }}</td>
                  <td>{{ row.plaintiff || "N/A" }}</td>
                  <td>{{ row.defendant || "N/A" }}</td>
                  <td>{{ row.courtName || "N/A" }}</td>
                  <td>{{ row.judgeName || "N/A" }}</td>
                  <td>{{ row.patentsAtIssue || "N/A" }}</td>
                  <td>{{ row.caseStatus || "N/A" }}</td>
                  <td>{{ row.terminationDate || "N/A" }}</td>
                  <td class="text-center">
                    <ng-container *ngIf="row.pdfFile; else noOtherPdf">
                      <i
                        class="fa fa-file-pdf pdf-icon"
                        title="Open case PDF"
                        (click)="openPdf(row)"
                        style="cursor: pointer; color: red"
                      ></i>
                    </ng-container>
                    <ng-template #noOtherPdf> N/A </ng-template>
                  </td>
                </tr>
                <tr *ngIf="row.expanded">
                  <td colspan="11">
                    <div
                      style="
                        padding: 10px;
                        background-color: #f8f9fa;
                        border-radius: 4px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);
                      "
                    >
                      <div
                        style="
                          font-weight: bold;
                          margin-bottom: 8px;
                          color: #495057;
                          font-size: 11px;
                        "
                      >
                        <i class="fa fa-info-circle text-info"></i> Appeal
                        Case(s)
                      </div>
                      <table
                        class="table table-bordered table-sm"
                        style="background-color: white; margin-bottom: 0"
                      >
                        <thead
                          style="background-color: #e9ecef; font-size: 11px"
                        >
                          <tr>
                            <th>Case Number</th>
                            <th>Court</th>
                            <th>Appellant</th>
                            <th>Filed Date</th>
                            <th>Case Status</th>
                            <th>Termination Date</th>
                            <th class="text-center">PDF</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let appeal of getFilteredAppeals(row.appealCases)
                            "
                          >
                            <td>{{ appeal["Appeal Case Number"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Court"] || "N/A" }}</td>
                            <td>{{ appeal["Appellant"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Filed Date"] || "N/A" }}</td>
                            <td>{{ appeal["Appeal Case Status"] || "N/A" }}</td>
                            <td>
                              {{ appeal["Appeal Termination Date"] || "N/A" }}
                            </td>
                            <td class="text-center">
                              <a
                                *ngIf="
                                  appeal['Appeal PDF Path'] &&
                                    appeal['Appeal PDF Path'] !== 'N/A';
                                  else noAppealPdf
                                "
                                (click)="
                                  openAppealPdf(appeal['Appeal PDF Path'])
                                "
                                style="
                                  color: #007bff;
                                  cursor: pointer;
                                  text-decoration: underline;
                                "
                              >
                                <i
                                  class="fa fa-file-pdf pdf-icon"
                                  style="color: red"
                                  title="Open appeal PDF"
                                ></i>
                              </a>
                              <ng-template #noAppealPdf>N/A</ng-template>
                            </td>
                          </tr>
                          <tr
                            *ngIf="
                              getFilteredAppeals(row.appealCases).length === 0
                            "
                          >
                            <td colspan="7" class="text-center text-muted">
                              No appeal cases available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>